import styled from "styled-components";

export const ButtonsContainer = styled.div`
    display: flex;
`;
ButtonsContainer.displayName = "ButtonsContainer";
